import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import LocalRepAction from '../../components/LocalRep/LocalRepAction';
import BackButton from '../../components/RecordVideo/BackButton';
import ThumbnailContainer from '../../components/RecordVideo/ThumbnailContainer';

import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';
import { goToInstructionsCard, goToEmailStart } from './actions';

import { ActionTypes } from '../../utils/enums';
import { copyFor } from '../../copy/copy';
import { isPortrait } from '../../utils/size';
import { isLongText } from '../../components/Shared/commonFunctions';

import {
    joinEnglish,
    districtInfo
} from '../../utils/localRepresentative/parser';

const RecordVideoConfirmation = props => {
    const [isSubmitting,setIsSubmitting] = useState(false)
    return (
    <TransitionContainer
        zIndex={5}
        isSubmitting={props.isSubmitting || isSubmitting}
        isBackTransition={props.isBackTransition}
    >
        <ConfirmationCard
            rightAlign
            thankYouText={props.thankYouText}
            thankYouTitle={props.thankYouTitle}
            peopleCount={props.peopleCount}
            useLocalRepresentative={props.useLocalRepresentative}
            customBackButton={
                <BackButton
                    onClick={()=>{
                        props.setExitingCardProps('recordvideo', props, props.exitingAction);
                        props.goToInstructionsCard({direction:'back'});
                    }}
                />
            }
            thumbnailComponent={
                <ThumbnailContainer
                    src={props.thumbnailURL}
                    href={props.videoURL}
                />
            }
            disableAltEndCardSharing={true}
            nextStepButton={
                <AutoScalingButtonSet id="recordVideoStartEmailButton">
                    <LocalRepAction
                        isLongText={
                            !isPortrait() &&
                            isLongText(props.thankYouText, 40)
                        }
                        action={{label: copyFor('buttons', 'sendVideo', 'recordvideo')}}
                        onClick={() => {
                            props.setExitingCardProps('recordvideo', props, props.exitingAction);
                            setIsSubmitting(true);
                            props.goToEmailStart();
                        }}
                    />
                </AutoScalingButtonSet>
            }
            {...props}
            hideImage={true}
        />
    </TransitionContainer>);
}

RecordVideoConfirmation.propTypes = {
    actionIdentifier: PropTypes.string,
    card: PropTypes.object,
    exitingAction: PropTypes.object.isRequired,
    isBackTransition: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    partnerName: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
    fullVideoURL: PropTypes.string,
    videoURL: PropTypes.string,
    thumbnailURL: PropTypes.string,
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'recordvideo',
            ['/recordvideo/successtoemail'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const partnerName = state.widget.activeAction.partner
                ? state.widget.activeAction.partner.name
                : 'Speakable';

        const localRepData = state.localRep.localRepData || {};
        const repDistrict = localRepData.district || 'your district';
        const repState = localRepData.stateName || 'your state';

        const reps = localRepData.representative;
        const repNames = reps.length > 0
                ? joinEnglish(
                      reps.map(rep => `${rep.displayName}${districtInfo(rep)}`)
                  )
                : `your legislators`;

        const thankYouText = 
            (state.widget.activeAction.postRecordDescription || 
            copyFor('postRecord', 'description', 'recordvideo'))
            .replace(/@localRepresentative/g, repNames)
            .replace(/@partnerName/g, partnerName)
            .replace(/@state/g, repState)
            .replace(/@district/g, repDistrict);

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            exitingAction: state.widget.activeAction,
            isBackTransition: state.recordVideo.isBackTransition || state.email.backButtonClicked,
            isSubmitting: state.recordVideo.isSubmitting,
            partnerName,
            thankYouText,
            thankYouTitle: state.widget.activeAction.postRecordTitle || copyFor('postRecordReps', 'title', 'recordvideo'),
            fullVideoURL: state.recordVideo.fullVideoURL,
            thumbnailURL: state.recordVideo.thumbnailURL,
            videoURL: state.recordVideo.videoURL,

        };
    },
    { setExitingCardProps, goToInstructionsCard, goToEmailStart },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.RecordVideo) return true;
            return next === prev;
        }
    }
)(RecordVideoConfirmation);
